/* sloü theme — cart (native Shopify checkout), bundle selector, waitlist → Klaviyo, UI.
 * Sections expose data via attributes; everything is guarded so missing nodes never throw.
 */
(function () {
  "use strict";

  var CFG = (function () {
    try {
      return JSON.parse(document.getElementById("ThemeConfig").textContent);
    } catch (e) {
      return { routes: { cart_add: "/cart/add.js", cart_change: "/cart/change.js", cart_update: "/cart/update.js", cart_clear: "/cart/clear.js", cart: "/cart.js" }, klaviyo: {}, handles: {} };
    }
  })();

  var money = function (cents) {
    return "€" + (cents / 100).toFixed(2);
  };

  /* ------------------------------------------------------------------ cart */
  var Cart = {
    async add(variantId, qty) {
      if (!variantId) return;
      const res = await fetch(CFG.routes.cart_add, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] }),
      });
      if (!res.ok) throw new Error("cart add failed");
      await Cart.render();
      Cart.open();
    },
    async change(line, qty) {
      await fetch(CFG.routes.cart_change, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: qty }),
      });
      await Cart.render();
    },
    async render() {
      const root = document.querySelector("[data-cart-drawer]");
      if (!root) return;
      const cart = await (await fetch(CFG.routes.cart)).json();
      const count = cart.item_count;
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
      const list = root.querySelector("[data-cart-items]");
      const empty = root.querySelector("[data-cart-empty]");
      const footer = root.querySelector("[data-cart-footer]");
      if (count === 0) {
        if (empty) empty.hidden = false;
        if (footer) footer.hidden = true;
        if (list) list.innerHTML = "";
        return;
      }
      if (empty) empty.hidden = true;
      if (footer) footer.hidden = false;
      if (list) {
        list.innerHTML = cart.items
          .map(function (it) {
            return (
              '<div class="flex gap-3 p-3 rounded-2xl bg-card border border-border">' +
              '<div class="w-16 h-16 rounded-xl overflow-hidden bg-cream flex-shrink-0">' +
              (it.image ? '<img src="' + it.image + '" alt="" class="w-full h-full object-cover">' : "") +
              "</div>" +
              '<div class="flex-1 min-w-0"><p class="font-bold lowercase truncate">' + it.product_title + "</p>" +
              '<p class="font-semibold mt-1">' + money(it.final_price) + "</p></div>" +
              '<button data-cart-remove="' + it.key + '" aria-label="remove" class="p-1 text-ink/50 hover:text-ink">' +
              '{{remove}}</button>'
            ).replace("{{remove}}", "✕");
          })
          .join("");
      }
      const subtotal = root.querySelector("[data-cart-subtotal]");
      if (subtotal) subtotal.textContent = money(cart.total_price);
      // restore a previously entered Instagram handle (saved as a cart attribute)
      const igEl = root.querySelector("[data-cart-ig]");
      if (igEl && !igEl.value && cart.attributes && cart.attributes.Instagram) {
        igEl.value = String(cart.attributes.Instagram).replace(/^@+/, "");
      }
    },
    open() {
      const d = document.querySelector("[data-cart-drawer]");
      if (d) d.setAttribute("data-open", "true");
    },
    close() {
      const d = document.querySelector("[data-cart-drawer]");
      if (d) d.setAttribute("data-open", "false");
    },
  };

  document.addEventListener("click", function (e) {
    const open = e.target.closest("[data-cart-open]");
    if (open) { e.preventDefault(); Cart.open(); }
    const close = e.target.closest("[data-cart-close]");
    if (close) { e.preventDefault(); Cart.close(); }
    const rm = e.target.closest("[data-cart-remove]");
    if (rm) { e.preventDefault(); Cart.change(rm.getAttribute("data-cart-remove"), 0); }
    const co = e.target.closest("[data-cart-checkout]");
    if (co) {
      e.preventDefault();
      (async function () {
        try {
          var igEl = document.querySelector("[data-cart-ig]");
          var ig = igEl ? igEl.value.trim().replace(/^@+/, "") : "";
          if (ig) {
            await fetch(CFG.routes.cart_update || "/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ attributes: { Instagram: "@" + ig } }),
            });
          }
        } catch (err) { /* never block checkout if the attribute save fails */ }
        window.location.href = "/checkout";
      })();
    }
    const wlo = e.target.closest("[data-waitlist-open]");
    if (wlo) {
      e.preventDefault();
      loadGeo(); // start resolving the visitor's location while they fill the form
      const m = document.querySelector("[data-waitlist-modal]");
      if (m) { m.setAttribute("data-open", "true"); const inp = m.querySelector('input[type="email"]'); if (inp) setTimeout(function () { inp.focus(); }, 60); }
    }
    const wlc = e.target.closest("[data-waitlist-close]");
    if (wlc) { e.preventDefault(); const mc = document.querySelector("[data-waitlist-modal]"); if (mc) mc.setAttribute("data-open", "false"); }
  });

  /* ------------------------------------------------------ buy box / selection */
  // BuyBoxData: { single:{id,price,compareAt,available}, bundle2:{...}, bundle3:{...} }
  var BuyBox = (function () {
    var data = (function () {
      try { return JSON.parse(document.getElementById("BuyBoxData").textContent); } catch (e) { return null; }
    })();
    if (!data) return null;

    var selected = "bundle2"; // default
    var labels = { single: "cap", bundle2: "bundle", bundle3: "3-cap bundle" };

    function current() { return data[selected] || {}; }

    function update() {
      var c = current();
      // option cards selected state
      document.querySelectorAll("[data-select]").forEach(function (btn) {
        btn.setAttribute("aria-pressed", btn.getAttribute("data-select") === selected ? "true" : "false");
      });
      // main + sticky CTA
      document.querySelectorAll("[data-atc]").forEach(function (btn) {
        btn.dataset.variantId = c.id || "";
        btn.disabled = !c.id || c.available === false;
      });
      document.querySelectorAll("[data-atc-id]").forEach(function (el) { el.value = c.id || ""; });
      document.querySelectorAll("[data-cta-price]").forEach(function (el) {
        el.textContent = c.price ? money(c.price) : "";
      });
      document.querySelectorAll("[data-cta-noun]").forEach(function (el) {
        el.textContent = labels[selected];
      });
      document.querySelectorAll("[data-sticky-label]").forEach(function (el) {
        el.textContent = (selected === "single" ? "1 cap" : selected === "bundle2" ? "2-cap bundle" : "3-cap bundle");
      });
    }

    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-select]");
      if (!btn) return;
      selected = btn.getAttribute("data-select");
      update();
    });

    document.addEventListener("submit", function (e) {
      var form = e.target.closest("[data-buybox-form]");
      if (!form) return;
      e.preventDefault();
      if (form.dataset.submitting === "1") return; // guard against rapid double-clicks stacking items
      var idEl = form.querySelector("[data-atc-id]");
      var vid = (idEl && idEl.value) || current().id;
      if (!vid) return;
      form.dataset.submitting = "1";
      var atc = form.querySelector("[data-atc]");
      if (atc) { atc.setAttribute("data-loading", "true"); atc.disabled = true; }
      // Buy now: empty the cart (so repeat clicks never accumulate), add ONLY the
      // selected variant, then go straight to checkout (payment).
      fetch(CFG.routes.cart_clear || "/cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" } })
        .then(function () {
          return fetch(CFG.routes.cart_add, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }),
          });
        })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); window.location.href = "/checkout"; })
        .catch(function () { HTMLFormElement.prototype.submit.call(form); });
    });

    // Bulletproof: also resolve variant ids client-side from the public product JSON
    // (/products/<handle>.js), so the buy box works even if all_products didn't
    // resolve server-side (e.g. preview / domain redirect / settings drift).
    (function enrich() {
      var h = CFG.handles || {};
      ["single", "bundle2", "bundle3"].forEach(function (key) {
        var handle = h[key];
        if (!handle) return;
        fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p || !p.variants || !p.variants.length) return;
            var v = p.variants[0];
            data[key] = data[key] || {};
            data[key].id = v.id;
            if (typeof v.available === "boolean") data[key].available = v.available;
            if (v.price != null) data[key].price = v.price;
            update();
          })
          .catch(function () {});
      });
    })();

    update();
    return { update: update };
  })();

  /* ----------------------------------------------------------- sticky CTA */
  (function () {
    var sticky = document.querySelector("[data-sticky-cta]");
    var anchor = document.getElementById("see-it-closer");
    if (!sticky || !anchor) return;
    function onScroll() {
      var show = anchor.getBoundingClientRect().top <= window.innerHeight * 0.5;
      sticky.setAttribute("data-visible", show ? "true" : "false");
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  })();

  /* -------------------------------------------------------------- gallery */
  document.querySelectorAll("[data-gallery]").forEach(function (g) {
    var track = g.querySelector("[data-gallery-track]");
    var dots = g.querySelectorAll("[data-gallery-dot]");
    var thumbs = g.querySelectorAll("[data-gallery-thumb]");
    if (!track) return;
    function setActive(i) {
      dots.forEach(function (d, k) { d.setAttribute("data-active", k === i ? "true" : "false"); });
      thumbs.forEach(function (t, k) { t.setAttribute("data-active", k === i ? "true" : "false"); });
    }
    track.addEventListener("scroll", function () {
      setActive(Math.round(track.scrollLeft / track.clientWidth));
    }, { passive: true });
    function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" }); }
    dots.forEach(function (d, i) { d.addEventListener("click", function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { go(i); }); });
  });

  /* ------------------------------------------------------------ accordion */
  document.addEventListener("click", function (e) {
    var trig = e.target.closest("[data-accordion-trigger]");
    if (!trig) return;
    var item = trig.closest("[data-accordion-item]");
    if (!item) return;
    var open = item.getAttribute("data-open") === "true";
    item.setAttribute("data-open", open ? "false" : "true");
    trig.setAttribute("aria-expanded", open ? "false" : "true");
  });

  /* ---------------------------------------------------------------- video */
  document.querySelectorAll("[data-video]").forEach(function (wrap) {
    var v = wrap.querySelector("video");
    if (!v) return;
    // keep the overlay/controls in sync with the real play state (so it can be paused)
    v.addEventListener("play", function () { wrap.setAttribute("data-playing", "true"); });
    v.addEventListener("pause", function () { wrap.setAttribute("data-playing", "false"); });
    var playBtn = wrap.querySelector("[data-video-play]");
    if (playBtn) playBtn.addEventListener("click", function () { v.play().catch(function () {}); });
    var pauseBtn = wrap.querySelector("[data-video-pause]");
    if (pauseBtn) pauseBtn.addEventListener("click", function () { v.pause(); });
    var mute = wrap.querySelector("[data-video-mute]");
    if (mute) mute.addEventListener("click", function () { v.muted = !v.muted; wrap.setAttribute("data-muted", v.muted ? "true" : "false"); });
  });

  /* ------------------------------------------------------------ countdown */
  /* Fixed-deadline first-drop timer. Reads [data-deadline] (ISO 8601), fills the
     child [data-cd] spans every second; shows zeros once the deadline passes.
     Fully guarded so missing nodes never throw. */
  (function () {
    var roots = document.querySelectorAll("[data-countdown]");
    if (!roots.length) return;
    function pad(n) { return (n < 10 ? "0" : "") + n; }
    function set(root, sel, val) {
      var el = root.querySelector('[data-cd="' + sel + '"]');
      if (el) el.textContent = val;
    }
    function tick() {
      roots.forEach(function (root) {
        var deadline = new Date(root.getAttribute("data-deadline") || "").getTime();
        var diff = isNaN(deadline) ? 0 : deadline - Date.now();
        if (diff <= 0) {
          set(root, "days", "00"); set(root, "hours", "00");
          set(root, "mins", "00"); set(root, "secs", "00");
          return;
        }
        set(root, "days", pad(Math.floor(diff / 86400000)));
        set(root, "hours", pad(Math.floor((diff % 86400000) / 3600000)));
        set(root, "mins", pad(Math.floor((diff % 3600000) / 60000)));
        set(root, "secs", pad(Math.floor((diff % 60000) / 1000)));
      });
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* ----------------------------------------------- waitlist → Klaviyo */
  function closeWaitlistSoon(form, msg) {
    var modal = form.closest("[data-waitlist-modal]");
    if (modal) setTimeout(function () { modal.setAttribute("data-open", "false"); if (msg) msg.textContent = ""; }, 1400);
  }

  /* best-effort visitor location from IP (no API key) — attached to the Klaviyo profile.
     Never required and never blocks the signup: if it fails or is slow, we subscribe without it. */
  var GEO = null;
  var geoPromise = null;
  function loadGeo() {
    if (geoPromise) return geoPromise;
    geoPromise = (async function () {
      try {
        var ctrl = new AbortController();
        var timer = setTimeout(function () { ctrl.abort(); }, 2500);
        var res = await fetch("https://ipwho.is/", { signal: ctrl.signal });
        clearTimeout(timer);
        var d = await res.json();
        if (d && d.success !== false && d.country) {
          GEO = { country: d.country, region: d.region || "", city: d.city || "", zip: d.postal || "", code: d.country_code || "" };
        }
      } catch (e) { /* ignore — location is optional */ }
      return GEO;
    })();
    return geoPromise;
  }

  document.querySelectorAll("[data-waitlist-form]").forEach(function (form) {
    form.addEventListener("submit", async function (e) {
      e.preventDefault();
      var emailEl = form.querySelector('input[type="email"]');
      var email = emailEl ? emailEl.value.trim() : "";
      var nameEl = form.querySelector("[data-waitlist-name]");
      var name = nameEl ? nameEl.value.trim() : "";
      var phoneEl = form.querySelector("[data-waitlist-phone]");
      var phone = phoneEl ? phoneEl.value.trim() : "";
      var msg = form.querySelector("[data-waitlist-msg]");
      if (!email || email.indexOf("@") === -1) { if (msg) msg.textContent = "please enter a valid email."; return; }
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.setAttribute("data-loading", "true");
      try {
        if (!CFG.klaviyo.publicKey || !CFG.klaviyo.listId) throw new Error("klaviyo not configured");
        // resolve location (best-effort) and attach it to the profile
        var geo = GEO || (await loadGeo());
        var profileAttrs = { email: email };
        if (name) profileAttrs.first_name = name;
        if (phone) profileAttrs.phone_number = phone;
        if (geo && geo.country) {
          var loc = { country: geo.country };
          if (geo.region) loc.region = geo.region;
          if (geo.city) loc.city = geo.city;
          if (geo.zip) loc.zip = geo.zip;
          profileAttrs.location = loc;
          profileAttrs.properties = { "Signup country": geo.country, "Signup city": geo.city || "" };
        }
        // Klaviyo client subscription API (public key, no secret)
        await fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(CFG.klaviyo.publicKey), {
          method: "POST",
          headers: { "Content-Type": "application/json", revision: "2024-10-15" },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: { data: { type: "profile", attributes: profileAttrs } },
              },
              relationships: { list: { data: { type: "list", id: CFG.klaviyo.listId } } },
            },
          }),
        });
        if (msg) msg.textContent = "you're in. we'll keep you posted.";
        form.reset();
        closeWaitlistSoon(form, msg);
      } catch (err) {
        if (msg) msg.textContent = "thanks! we'll be in touch.";
        form.reset();
        closeWaitlistSoon(form, msg);
      } finally {
        if (btn) btn.removeAttribute("data-loading");
      }
    });
  });

  /* initial cart count */
  if (document.querySelector("[data-cart-drawer]")) Cart.render();
})();
